import type { FC } from 'react';

import { TeamMembersRequestStatus } from '__generated__/GQL';
import Callout from 'components/_core/Callout';

import { type ExpenseRequestSidebarItemFragment } from '../../../../../../hooks/useExpenseClaimRequestDetail/expenseClaimRequestDetail.gql';
import { locales } from './locales';

interface RequestStatusCalloutProps {
  request: ExpenseRequestSidebarItemFragment;
}

const PROCESSING_REQUEST_STATUSES = new Set([
  TeamMembersRequestStatus.Approved,
  TeamMembersRequestStatus.Processed,
]);

export const RequestStatusCallout: FC<RequestStatusCalloutProps> = ({
  request,
}) => {
  if (
    request.status === TeamMembersRequestStatus.Canceled &&
    request.cancelReason !== null
  ) {
    return (
      <Callout hideIcon variant="error">
        <Callout.Title>{locales.callouts.canceled.title}</Callout.Title>
        <Callout.Content>
          {locales.callouts.canceled.description}
        </Callout.Content>
      </Callout>
    );
  }

  if (request.status === TeamMembersRequestStatus.Pending) {
    return (
      <Callout hideIcon variant="info">
        <Callout.Title>{locales.callouts.pending.title}</Callout.Title>
        <Callout.Content>
          {locales.callouts.pending.description}
        </Callout.Content>
      </Callout>
    );
  }

  if (PROCESSING_REQUEST_STATUSES.has(request.status)) {
    return (
      <Callout hideIcon variant="info">
        <Callout.Title>{locales.callouts.processing.title}</Callout.Title>
        <Callout.Content>
          {locales.callouts.processing.description}
        </Callout.Content>
      </Callout>
    );
  }

  return null;
};
